<span class="p-inputgroup-addon">
  <p-colorPicker [(ngModel)]="value" (ngModelChange)="onChange(value)" appendTo="body"></p-colorPicker>
</span>
<input
  type="text"
  pInputText
  [(ngModel)]="value"
  (ngModelChange)="onChange(value)"
  (keydown.esc)="inputReset($event)"
  (focus)="inputFocus($event)"
  (blur)="inputBlur($event)"
/>
